import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Footer from '../Footer/Main';
import Navbar from '../Navbar/Main';
import { Pagination } from '../DataTable';
import BGPH1 from '../../assets/images/backgrounds/page-header-bg-1-1.jpg';

export const Anreports = () => {
    const [clicked, setClicked] = useState(null);
    const [doc, setFaqs] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedCategory, setSelectedCategory] = useState('Annual_Report');
    const ITEMS_PER_PAGE = 10;

    useEffect(() => {
        axios.get(`/annual_report`)
            .then((response) => {
                setFaqs(response.data);
            })
            .catch((error) => console.log(error));
    }, []);

    const categories = ['Annual_Report', 'Financial_Stability_Report','MPFS_Report','Monetary_Policy_Report','Economic_Bulletin','Weekly_Bulletin'];

    // Filter FAQs based on selected category
    const filteredFaqs = useMemo(() => {
        return doc.filter(faq => {
            const category = faq.category || 'Other';
            return category === selectedCategory;
        });
    }, [doc, selectedCategory]);

    const paginatedFaqs = useMemo(() => {
        return filteredFaqs.slice(
            (currentPage - 1) * ITEMS_PER_PAGE,
            (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
        );
    }, [filteredFaqs, currentPage]);

    // Category metadata with icons
    const categoryMeta = [
    { key: 'Annual_Report', label: 'Annual Reports', icon: '📘' },          // Blue book
    { key: 'Financial_Stability_Report', label: 'Financial Stability Report', icon: '💹' }, // Chart increasing
    { key: 'MPFS_Report', label: 'MPFSS Report', icon: '📊' },             // Bar chart
    { key: 'Monetary_Policy_Report', label: 'Monetary Policy Report', icon: '💰' }, // Money bag
    { key: 'Economic_Bulletin', label: 'Economic Bulletin', icon: '🌍' }, // Newspaper
    { key: 'Weekly_Bulletin', label: 'Weekly Bulletin', icon: '📰' }, // Newspaper
    //{ key: 'Other_Report', label: 'Foreign Private Capital', icon: '🌍' } // Globe
    ];

        // Count FAQs per category
        const faqCounts = useMemo(() => {
            const counts = {
                Annual_Report: 0,
                Financial_Stability_Report: 0,
                MPFS_Report: 0,
                Monetary_Policy_Report: 0,
                Economic_Bulletin: 0,
                Weekly_Bulletin: 0,
                //Other_Report: 0
            };
            doc.forEach(faq => {
                const cat = faq.category || 'Other_Report';
                if (counts[cat] !== undefined) {
                    counts[cat]++;
                } else {
                    counts.Other_Report++;
                }
            });
            return counts;
        }, [doc]);


    const handleTabClick = (category) => {
        setSelectedCategory(category);
        setCurrentPage(1); // Reset pagination when switching tab
        setClicked(null);  // Close any open accordion
    };

    return (
        <>
            <Navbar />
            <div className="stricky-header stricked-menu main-menu">
                <div className="sticky-header__content"></div>
            </div>

        <section className="page-header">
            <div className="page-header__bg"   ></div>
            <div className="container">
                <ul className="thm-breadcrumb list-unstyled">
                    <li><Link to="/">Home</Link></li>
                    <li><span>Reports</span></li>
                </ul>
                 <div className="surrounding slider-one__title">
                  Welcome to our comprehensive report section, where we explore the latest insights, analysis, 
					and findings on various topics and functions that fall into our mandate. 
					Here, you'll discover a wealth of information aimed at providing clarity and understanding on key issues impacting the financial industry.
					Through meticulously curated reports, we aim to offer valuable perspectives, trends, and data-driven insights to our readers. 
					This section serves as a valuable resource hub for all.                
				</div> 
            </div>
        </section>

            <section className="service-four pt-50 pb-50">
                <div className="container">
                    <div className="row service-four__inner"> 
                    {/* Category Tabs */}
                 <div className="faq-tabs mb-4 text-center">
                    {categoryMeta.map(({ key, label, icon }) => (
                        <button
                        key={key}
                        onClick={() => handleTabClick(key)}
                        className={`faq-tab-button position-relative ${selectedCategory === key ? 'active' : ''}`}
                        >
                        <span className="me-2">{icon}</span>
                        {label}
                        <span className="faq-count-circle">
                            {faqCounts[key] || 0}
                        </span>
                        </button>
                    ))}
                    </div>


                    {/* FAQ Accordions for Selected Category */}
                    {paginatedFaqs.length === 0 ? (
                        <p className="text-center">No Reports found in this category.</p>
                    ) : (
                        paginatedFaqs.map((item, index) => (
                            <div
                                key={item.name || index}
                                className={`accrodion-grp service-details__accrodion mb-3 ${clicked === item.name ? "active" : ""}`}
                                data-grp-name="service-details__accrodion-1"
                            >
                                <div className="accrodion wow fadeInUp" data-wow-delay="0ms">
                                    <div
                                        className="accrodion-title"
                                        onClick={() => setClicked(clicked === item.name ? null : item.name)}
                                    >
                                        <h4>{item.name}</h4>
                                        <span className="accrodion-icon"></span>
                                    </div>
                                    {clicked === item.name && (
                                        <div className="accrodion-content">
                                             <div className="inner_doc" >
                                                <p>{item.summary}</p>
                                                    <Link to={item.file} target="_blank">Download/View <i className="fa fa-file-pdf"></i></Link>
                                             </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))
                    )}

                    <div className="d-flex justify-content-center mt-4">
                        <Pagination
                            total={filteredFaqs.length}
                            itemsPerPage={ITEMS_PER_PAGE}
                            currentPage={currentPage}
                            onPageChange={page => setCurrentPage(page)}
                        />
                    </div>
                </div>
                
                    </div>
            </section>

            <Link to="#" data-target="html" className="scroll-to-target scroll-to-top">
                <i className="fa fa-angle-up"></i>
            </Link>
            <Footer />
        </>
    );
};

export default Anreports;
